import _ from "lodash";
import { fetchLookupWithConfig, fetchActualYieldTable, fetchHarvestConstraints, fetchSiteConfig, setHarvestConstraints, setSpecSize } from "./harvestOptimiser.storage.js";
import { getBroccoliOptimiserForecastHarvestPlan, recomputeHarvestPlan,  } from "../../../utils/api.js";

// REST API calls
export { recomputeHarvestPlan };

export async function getOptimisedHarvestPlan(organization, site, constraints=null) {
  const response = await getBroccoliOptimiserForecastHarvestPlan(organization, site, constraints);
  const rows = response.data?.rows.map((row) => {
    return {
      id: row.block + "_" + row.paddock, // Create a unique ID by combining block and paddock
      paddock: row.paddock,
      block: row.block,
      area: row.area_ha,
      site: row.site,
      organization: row.organization,
      harvest_pass_day_1_date: row.pass1_date,
      harvest_pass_day_1_yield: row.pass1_yield_kg,
      harvest_pass_day_2_date: row.pass2_date,
      harvest_pass_day_2_yield: row.pass2_yield_kg,
      total_yield: row.total_yield_kg,
      location_group: row.location_group,
      date_of_forecast: row.date_of_forecast,
    }
  })

  return rows;
}

// Supabase calls
export async function fetchDataFromSupabase(currentSiteName) {
  const [lookupTable, actualYieldTable, configTable] = await Promise.all([
    fetchLookupWithConfig(currentSiteName),
    fetchActualYieldTable(currentSiteName),
    fetchHarvestConstraints(currentSiteName),
  ]);

  return { lookupTable, actualYieldTable, configTable };
}

export async function fetchSiteConfigFromSupabase(siteId) {
  const siteConfigRows = await fetchSiteConfig(siteId);
  const siteConfig = siteConfigRows?.[0] ?? null;
  return {siteConfig}
}

export async function fetchHarvestConstraintsFromSupabase(siteId, blockName) {
  return await fetchHarvestConstraints(siteId, blockName)
}

export async function setHarvestConstraintsToSupabase(siteName, constraints) {
  return await setHarvestConstraints(siteName, constraints)
}

export async function setSpecSizeToSupabase(siteName, constraints){
  return await setSpecSize(siteName, constraints)
}